import { styled } from "@mui/styles";

export const Title = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "20px",
  textAlign: "left",
  color: "#0055A4",
}));
